import React from "react";
const Icon = (props) => {
    if (!props.attributes || !props.attributes.iconName) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("i", { className: "icon " +
            props.attributes.iconName +
            " " +
            (props.attributes.iconColor || "") }, props.attributes.iconName));
};
export default Icon;
